import { useQuery } from '@tanstack/react-query';
import { FileText } from 'lucide-react';

import { fetchClientePeticoesIniciais, type PeticaoInicialResumo } from '@/api/clientes';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';
import { classifyError } from '@/lib/errors';
import { formatDate } from '@/lib/formatters';
import { queryKeys } from '@/lib/pwa/queryConfig';

export function ClientePeticoesTab({ clienteId }: { clienteId: string }) {
  const { data, isLoading, error } = useQuery<PeticaoInicialResumo[]>({
    queryKey: queryKeys.clientes.peticoesIniciais(clienteId),
    queryFn: () => fetchClientePeticoesIniciais(clienteId),
  });

  if (isLoading) return <div className="flex justify-center py-6"><Spinner size={32} label="Carregando petições..." /></div>;
  if (error) return <Alert variant="destructive"><AlertDescription>{classifyError(error).message}</AlertDescription></Alert>;
  if (!data?.length) return <p className="py-6 text-center text-sm text-muted-foreground">Nenhuma petição inicial vinculada.</p>;

  return (
    <div className="space-y-2">
      {data.map((p) => (
        <div key={p.id} className="flex items-center gap-3 rounded-md border border-border/40 p-3">
          <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="min-w-0 flex-1">
            <p className="break-words text-sm font-medium">{p.classe_processual_nome}</p>
            <p className="text-xs text-muted-foreground">{p.tribunal_nome} - {formatDate(p.created_at)}</p>
          </div>
          <Badge variant="outline" className="shrink-0 text-xs">{p.status}</Badge>
        </div>
      ))}
    </div>
  );
}
